import { render, staticRenderFns } from "./texting-form-addressees.vue?vue&type=template&id=243ea8dc"
import script from "./texting-form-addressees.vue?vue&type=script&lang=js"
export * from "./texting-form-addressees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports